import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { inject } from '@angular/core';

import { CanDeactivateFn } from '@angular/router';
import { ModalPromptService, PromptOptions } from '../helper-components/modal-prompt.service';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

export const pendingChangesGuard: CanDeactivateFn<ComponentCanDeactivate> = (
  component: ComponentCanDeactivate
): boolean | Observable<boolean> => {
  const promptService = inject(ModalPromptService);

  const options: PromptOptions = {
    header: 'Cancel changes?',
    body: 'You have unsaved changes. Press Cancel to stay in this page and save these changes, or OK to discard these changes.'
  };

  if (component.canDeactivate()) {
    return true;
  }

  // OK → true (leave); Cancel → false (stay). Router only cancels when result === false.
  return promptService.openModal(null, true, options).pipe(
    map((result) => result === true)
  );
};

/**
 * @deprecated Use the functional `pendingChangesGuard` instead.
 * Kept for backward compatibility with any class-token references.
 */
export class PendingChangesGuard {
  static ɵfac = () => pendingChangesGuard;
}
